import React from 'react';
import type { PolicyBlock } from '../../types/policy';
import { company } from '../../data/company';
export type PolicyLayoutSection = {
  id: string;
  heading: string;
  body?: React.ReactNode;
  blocks?: PolicyBlock[];
};
type PolicyLayoutProps = {
  title: string;
  lead: string;
  sections: PolicyLayoutSection[];
};
function renderBlocks(blocks: PolicyBlock[]) {
  return blocks.map((b, i) => typeof b === 'string' ? <p key={i} data-id="element-913" data-mp="2tznc4cesmqi2">{b}</p> : <ul key={i} className="list-disc space-y-1.5 pl-5 marker:text-marine" data-id="element-914" data-mp="2yrwv18hhqqau">
        {b.list.map(li => <li key={li} data-id="element-915" data-mp="2l0s2srggd0aj">{li}</li>)}
      </ul>);
}
export function PolicyLayout({
  title,
  lead,
  sections
}: PolicyLayoutProps) {
  return <div className="mx-auto max-w-site px-5 py-14 md:px-8 md:py-20" data-id="element-916" data-mp="2q04mx4fxvt9f">
      <h1 className="max-w-3xl font-display text-5xl font-semibold uppercase leading-[0.95] md:text-6xl" data-id="element-917" data-mp="2b22k4wgqfbt8">{title}</h1>
      <p className="mt-5 max-w-2xl text-lg text-titanium" data-id="element-918" data-mp="2g043zjlzff5r">{lead}</p>
      <p className="mt-3 text-sm text-titanium/60" data-id="element-919" data-mp="1e4g5131vxeq9">Last updated: {company.policiesUpdated}</p>

      <div className="mt-14 grid gap-12 lg:grid-cols-[240px_1fr]" data-id="element-920" data-mp="196ebtpaqvz12">
        <nav aria-label="On this page" className="hidden lg:block" data-id="element-921" data-mp="197za9q06k247">
          <ul className="sticky top-32 max-h-[calc(100vh-10rem)] space-y-2 overflow-y-auto border-l mf-hairline pl-4 text-sm" data-id="element-922" data-mp="1n4clwii199ar">
            {sections.map(s => <li key={s.id} data-id="element-923" data-mp="vdyhrdztnbca">
                <a href={`#${s.id}`} className="text-titanium hover:text-white" data-id="element-924" data-mp="vf9l5cpcuh2v">
                  {s.heading}
                </a>
              </li>)}
          </ul>
        </nav>
        <div className="max-w-3xl space-y-12" data-id="element-925" data-mp="147tjsd5nclnp">
          {sections.map(s => <section key={s.id} id={s.id} className="scroll-mt-32" data-id="element-926" data-mp="zftfk8ijn6lb">
              <h2 className="font-display text-2xl font-semibold uppercase tracking-[0.03em]" data-id="element-927" data-mp="bqhanku91kot">{s.heading}</h2>
              <div className="mt-3 space-y-3 leading-relaxed text-titanium" data-id="element-928" data-mp="7p5fkzslw798">
                {s.body}
                {s.blocks && renderBlocks(s.blocks)}
              </div>
            </section>)}
        </div>
      </div>
    </div>;
}